export default __webpack_public_path__ + "static/media/paypal_logo.34a561b1.webp";